import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { FileUploadModule } from 'ng2-file-upload';
import { ComumModule } from '../comum.module';
import { BarraUploadFileComponent } from './barra-upload-file.component';
import { BarraUploadService } from './barra-upload-service/barra-upload.service';


@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    ComumModule,
    HttpModule,
    FormsModule,
    FileUploadModule
  ],
  declarations: [
     BarraUploadFileComponent,
  ],
  providers: [
    FileUploadModule,
    BarraUploadService,
  ],
  exports: [
    BarraUploadFileComponent,
  ],
})
export class BarraUploadModule { }
